import type { ConfigurationContextValue } from "./ConfigurationContext";
import arkaIsotype from "./logos/arka-isotype.png";
import { getActiveBlueprint } from "@/lib/tenant";

const activeBlueprint = getActiveBlueprint();

export const defaultDarkModeLogo = arkaIsotype;
export const defaultLightModeLogo = arkaIsotype;

export const defaultCurrency = activeBlueprint.currency;
export const defaultTitle = activeBlueprint.title;
export const defaultCompanySectors = activeBlueprint.companySectors;
export const defaultDealStages = activeBlueprint.dealStages;
export const defaultDealPipelineStatuses = activeBlueprint.dealPipelineStatuses;
export const defaultDealCategories = activeBlueprint.dealCategories;
export const defaultNoteStatuses = activeBlueprint.noteStatuses;
export const defaultTaskTypes = activeBlueprint.taskTypes;

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
